export default "__VITE_ASSET__BgFxoxDW__"